import { PlayerAhoyEvent } from '../../player_ahoy_event';

function sendEvent(action, content_id, feature, additional_props = {}){
  const props = Object.assign({
    action: action,
    content_id: content_id,
    content_type: 'vod',
    feature: feature
  }, additional_props)

  PlayerAhoyEvent.sendEvent('CONTENT', props, 'VIDIO::');
}

export function sendImpressionEvent(id){
  sendEvent('impression', id, 'next-video');
}

export function sendClickEvent(id, feature = 'next-video', source_id = null){
  let additionalProps = source_id == null ? {} : { source_id: source_id, source_type: 'vod' };
  sendEvent('click', id, feature, additionalProps);
}

export function sendAutoplayEvent(id){
  sendEvent('autoplay', id, 'next-video');
}
